export default "__VITE_ASSET__DLhDqjJO__"